import { mapState, mapActions, mapGetters } from 'vuex';

import { useDataLoading, usePagination, useSearch } from '@mixins/factories';

import ColoredStateBadge from '@components/coloredStateBadge';
import OuterLink from '@components/outerLink';

const dataLoadingOptions = { getterName: 'getBaskets', contentName: 'baskets' };
const paginationOptions = { contentName: 'baskets' };
const searchOptions = {
  initialSearchDataStates: [
    'id', 'state', 'operation', 'machineId',
  ],
  customTypes: {
    state: 'number',
    machineId: 'number',
  },
};

const basketsHeaders = Object.freeze([
  { text: 'Machine', value: 'machine' },
  { text: 'Operation', value: 'operation' },
  { text: 'Substrate', value: 'substrate' },
  { text: 'State', value: 'state' },
  { text: 'Sub State', value: 'substate' },
  { text: 'Jobs Count', value: 'jobsCount' },
  { text: 'Total Quantity', value: 'totalQuantity' },
  { text: 'Shipping Periods', value: 'shippingPeriods' },
  { text: 'Created Date', value: 'created', width: '225px' },
  { text: 'Last Update', value: 'lastUpdate', width: '225px' },
  { text: '', value: 'actions', width: '5%' },
]);

export default {
  name: 'Baskets',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],
  components: {
    ColoredStateBadge,
    OuterLink,
  },
  data() {
    return {
      basketsHeaders,
    };
  },
  computed: {
    ...mapState('baskets', ['baskets']),
    ...mapState('machines', {
      machinesOptions: ({ machines }) => machines.map(({ id: value, name: text }) => ({
        value,
        text,
      })),
    }),
    ...mapState('locations', ['suffix']),
    ...mapGetters('enums', ['basketStateEnum', 'jobOperationStateEnum']),
    basketStateOptions() {
      return this.basketStateEnum.map(({ value, name: text }) => ({ value, text }));
    },
    jobOperationStateOptions() {
      return this.jobOperationStateEnum.map(({ name }) => ({ value: name, text: name }));
    },
    searchFieldsConfig() {
      return [
        {
          value: 'id', label: 'ID', type: 'text', flex: 'lg3',
        },
        {
          value: 'state',
          items: this.basketStateOptions,
          label: 'State',
          type: 'select',
          flex: 'lg3',
        },
        {
          value: 'operation',
          items: this.jobOperationStateOptions,
          label: 'Operation',
          type: 'select',
          flex: 'lg3',
        },
        {
          value: 'machineId',
          items: this.machinesOptions,
          label: 'Machine',
          type: 'select',
          flex: 'lg3',
        },
      ];
    },
  },
  watch: {
    suffix() {
      this.$_refreshData();
      this.$nextTick(() => this.getMachines());
    },
  },
  created() {
    this.getMachines();
  },
  methods: {
    ...mapActions('baskets', ['getBaskets']),
    ...mapActions('machines', ['getMachines']),
    getDimensions(w, h) {
      return w < h ? `${w}×${h}` : `${h}×${w}`;
    },
  },
};
